/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { useState } from "react";
import { Link } from "react-router-dom";
import { supabase } from "../utils/supabaseClient.js";
import BrandLogo from "./BrandLogo.jsx";

// Step 1 of password reset: email the user a recovery link that lands on
// /reset-password (where they set a new password).
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setStatus(null);
    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/reset-password`,
      });
      if (error) throw error;
      // Generic confirmation — don't reveal whether the email exists.
      setStatus({ ok: true, msg: "If that email has an account, a reset link is on its way." });
    } catch (err) {
      setStatus({ ok: false, msg: err.message || "Could not send reset email." });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <section className="auth-card">
        <div className="auth-logo">
          <BrandLogo />
        </div>
        <h1>Reset your password</h1>
        <p className="auth-sub">Enter your email and we'll send you a reset link.</p>

        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </label>
          <button className="btn" type="submit" disabled={busy}>
            {busy ? "Sending..." : "Send reset link"}
          </button>
        </form>

        {status && <p className={status.ok ? "success" : "error"}>{status.msg}</p>}

        <p className="auth-foot muted">
          Remembered it? <Link to="/login">Back to log in</Link>
        </p>
      </section>
    </div>
  );
}
